require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./brand-design-pennant-park.json") })
        }
      }, "path---brand-design-pennant-park");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---brand-design-pennant-park!./.cache/json/brand-design-pennant-park.json
// module id = 378
// module chunks = 231608221292675